export const validateContactForm = (form) => {
    const errors = {};
    const formData = new FormData(form);

    // Walidacja imienia i nazwiska
    const nameSurname = formData.get('name_surname');
    if (!nameSurname || nameSurname.trim() === '') {
        errors.name_surname = 'Pole jest wymagane';
    }

    // Walidacja telefonu
    const phone = formData.get('phone');
    if (!phone || phone.trim() === '') {
        errors.phone = 'Pole jest wymagane';
    } else if (!/^[0-9\s+()-]{9,}$/.test(phone)) {
        errors.phone = 'Nieprawidłowy format numeru telefonu';
    }

    // Walidacja emaila
    const email = formData.get('email');
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
        errors.email = 'Adres email jest wymagany';
    } else if (!emailRegex.test(email)) {
        errors.email = 'Podaj poprawny adres email';
    }


    // Walidacja opisu projektu
    const projectDescription = formData.get('project_description');
    if (!projectDescription || projectDescription.trim() === '') {
        errors.project_description = 'Pole jest wymagane';
    }

    return errors;
};